import { AuthorListCardProps, AuthorResponseItem } from '../types';

const convertAuthorItem = (
  authors: AuthorResponseItem[]
): AuthorListCardProps[] => {
  return authors.map((author) => ({
    id: author.id,
    name: author.name,
    description: author.description,
    tagLine: author.tagline,
    subscriptionCount: author.subscription_count,
    isCompany: author.is_company,
    isSubscribed: author.is_subscribed,
    count: {
      view: author.total_view_count,
      like: author.total_like_count,
      scrap: author.total_scrap_count,
      subscription: author.subscription_count,
    },
    urlIdentifier: author.author_url_identifier,
    imageUrl: author.image_url,
    mostPublishedCategory: author.most_published_category_list,
  }));
};

export default convertAuthorItem;
